/** @ngInject */
export default function notifiersService($http) {
  const URL_BASE = 'oc-api/operations/web-hooks';

  return {
    getNotifiers,
    update,
    remove,
  };

  function getNotifiers(notificationSystemId) {
    return $http.get(`${URL_BASE}/${notificationSystemId}/merchant-notifiers`);
  }

  function update(notificationSystemId, notifier) {
    return $http.put(`${URL_BASE}/${notificationSystemId}//merchant-notifiers/${notifier.id}`, notifier);
  }

  function remove(notificationSystemId, notifierId) {
    return $http.delete(`${URL_BASE}/${notificationSystemId}//merchant-notifiers/${notifierId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/notifiers/notifiers.service.js